import { useStateCurrentLocation } from '@angeplus/prever-component-lib';

export const useSlugState = () => {
  const currentLocation = useStateCurrentLocation();
  const slug = currentLocation?.acronym || 'PR';

  return { slug };
};
